<juno-libs-ui-input
  type="search"
  [(value)]="query"
  [placeholder]="'SEARCH'"
  labelClass="hidden"
  [appliedClasses]="appliedClasses()"
  [prefixIconConfig]="{ icon: 'minimalistic-magnifier-outline', iconClasses: 'text-ink-muted!' }"
/>
